import { Pipe, PipeTransform } from '@angular/core';
import { MimesysTranslationsService } from 'src/app/core/services/mimesys-translations.service';

@Pipe({
  name: 'translateMimesys',
  pure: false // Mark impure so it updates when language changes
})
export class TranslateMimesysPipe implements PipeTransform {
  constructor(private mimesysTranslationsService: MimesysTranslationsService) {}

  transform(value: string): string {
    return this.mimesysTranslationsService.translate(value);
  }
}
